import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant90BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/90-bpm-water-plant']} path="/90-bpm-water-plant" />
);

export default WaterPlant90BPM;
